export const getOrderValidationErrorId = (
  errorCode?: string
): string | null => {
  if (!errorCode) return null;

  if (errorCode.indexOf('CREATE_STRIPE_ORDER.') !== -1) {
    return 'MERCH.PRODUCT_SAMPLE.VALIDATION.ERROR.ADDRESS';
  }

  if (errorCode.indexOf('ORDER.') !== -1) {
    return 'MERCH.PRODUCT_SAMPLE.VALIDATION.ERROR.SHIPPING_COST';
  }

  return 'MERCH.PRODUCT_SAMPLE.VALIDATION.ERROR';
};
